import React, { Component } from 'react';
import { Switch,Route } from "react-router-dom";
import Routes from "../Routes"; 
import { MCbrowser } from '../Context/browserContext';

class Main extends Component{

    constructor(props) {
        super(props);
        let Routes1=new Routes();
        this.routes=Routes1.get();
    }

    componentDidMount() {
        let pageBreadcrumbs = this.context.page.pageBreadcrumbs;
        if(pageBreadcrumbs!=null){
            pageBreadcrumbs.current.setRoutes(this.routes);
        }
    }

    render(){
        return (
            <React.Fragment>
                <Switch>
                {this.routes.map((route, index) => (
                    // Render more <Route>s with the same paths as
                    // above, but different components this time.
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        children={<route.main />}
                    />
                ))}
                </Switch>
            </React.Fragment>
        )
    }
 } 
Main.contextType = MCbrowser;
export default Main;
